import workerUrl from 'pdfjs-dist/build/pdf.worker.mjs?url';
import { pdfjs } from 'react-pdf';

// Points pdf.js at its bundled worker exactly once; import this module for its
// side effect wherever react-pdf's <Document>/<Page> are rendered.
pdfjs.GlobalWorkerOptions.workerSrc = workerUrl;
